function first_value(values) {
  return values.find(Boolean);
}

export function role_name_from_payload(role = {}) {
  return String(first_value([
    role.role, role.role_name, role.name, 'Unnamed role'
  ])).trim();
}

export function role_id_from_payload(role = {}) {
  return first_value([
    role.id, role.role_id, role.pk, role.name, role.role
  ]) || null;
}

export function user_name_from_payload(profile = {}) {
  const user = profile.user || profile;
  const full_name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
  return String(first_value([
    full_name, user.name, user.full_name, user.email, 'Unnamed user'
  ])).trim();
}

export function map_user(profile = {}) {
  const user = first_value([profile.user, profile]);
  const role = first_value([user.role, profile.role, {}]);
  const role_name = typeof role === 'string' ? role : role_name_from_payload(role);
  return {
    id: first_value([profile.user_id, user.id, profile.id]),
    name: user_name_from_payload(profile),
    email: first_value([user.email, profile.email]) || '',
    role_id: first_value([role.id, user.role_id, profile.role_id]) || null,
    role: first_value([role_name, 'User']),
    is_active: active_value(profile.is_active, user.is_active)
  };
}

function active_value(profile_value, user_value) {
  return profile_value === undefined || profile_value === null ? user_value : profile_value;
}

export function badge_class_for_index(index) {
  const badges = ['is-tier-one', 'is-tier-two', 'is-tier-three', 'is-read-only'];
  return badges[index % badges.length];
}
